export interface NutritionPer100g {
  readonly kcal: number;
  readonly proteinGrams: number;
  readonly carbsGrams: number;
  readonly fatGrams: number;
}

/** Plausible ceiling for a per-100 g component; nothing edible exceeds this density. */
export const MAX_NUTRITION_PER_100G = 1_000;
